import { APP_BASE_HREF } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AdditionalInfoService } from '@app/_core/services/additional-info.service';
import { LoaderService } from '@app/_core/services/loader.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { ConfigService } from '@app/config.services';
import { MessageDialogComponent } from '@app/pages/common/message-dialog/message-dialog.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-provider-information',
  templateUrl: './provider-information.component.html',
  styleUrl: './provider-information.component.scss'
})
export class ProviderInformationComponent {
  
    displayProviderInfo:boolean=false
    modalRef:BsModalRef
    @Input() FieldsConf:any
    @Input() ReadOnly:any
    providerSearchData:ProviderSearch;
    showTabularData: boolean;
    sortOrder: string='Asc';
    ProviderData: any=[];
    currentpage=0;
    User: any;
    Company: any;
    ProviderName: string='';
    fieldDetails: any[]=[];
    mappedDetails: any={};
    constructor(private http: HttpClient, private modalService: BsModalService,
       private loaderService:LoaderService,
       private configService:ConfigService,
       private additionalinfoService:AdditionalInfoService,
       private webStorageService: WebStorageService,
       @Inject(APP_BASE_HREF) public baseHref: string) {
      this.providerSearchData=new ProviderSearch()
    }
    ngAfterViewInit(): void {
      
    }
  
    async ngOnInit(): Promise<void> {
     this.User = this.webStorageService.getItemFromSessionStorage('currentUser');
     this.Company = this.webStorageService.getItemFromSessionStorage('company');
     console.log("ProviderInfo:",this.FieldsConf);
     this.fetchAndLoadData();
     this.FieldsConf=null
     if(!this.FieldsConf|| (this.FieldsConf && this.FieldsConf["Groups"] && (this.FieldsConf["Groups"].length<=0)))
     {
      // let data:any =await this.readFieldsConfigSample();
      console.log("mock data for fields")
      let data:any =await this.configService.readFileContent('/assets/provider-info-fields.json');
      this.loaderService.display(false);
      // if(data && "Groups" in data && "Fields" in data["Groups"][0]){
      //   this.FieldsConf["Groups"]=data["Groups"];
      // }
       if(data && data.length>0){
      //this.FieldsConf["Groups"]=data["Groups"];
      this.fieldDetails=data
    }
     }
    }
    fetchAndLoadData()
    {
      this.providerSearchData=this.additionalinfoService.getProviderSearchData();
      if(!this.providerSearchData){
        this.providerSearchData=new ProviderSearch();
      }
      this.ProviderData=this.additionalinfoService.getProviderTabularData();
      let providerInfoData=this.additionalinfoService.getProviderInfoData();
      if(providerInfoData)
      {
        this.showTabularData=false;
        this.displayProviderInfo=true;
        this.mapProviderDetails(providerInfoData);
      }
      else if(this.ProviderData){
        if(this.ProviderData.length>1)
        {
          this.displayProviderInfo=false;
          this.showTabularData=true;
        }
      }
    }
    clearSearchResults()
    {
      this.displayProviderInfo=false;
      this.showTabularData=false;
      this.providerSearchData=new ProviderSearch();
      this.additionalinfoService.setProviderInfoData(null);
      this.additionalinfoService.setProviderTabularData(null);
      this.additionalinfoService.setProviderSearchData(null);
    }

    providerInfoSearchData():boolean
    {
      if(this.providerSearchData.Npi.trim()=='' && this.providerSearchData.FedId.trim()=='' && 
      this.providerSearchData.FullName.trim()=='' && this.providerSearchData.State.trim()==''){
        return false;
      }
      return true;
    }
    // providerInfoSearchData():boolean
    // {
    //   for (const key in this.providerSearchData)
    //     {
    //       let value=this.providerSearchData[key];
    //       if(value!=="" && value!==null && value!==undefined )
    //       {
    //         return true;
    //       }
    //     }
    //     return false;
    // }

  providerInfoSearchPayload(searchData)
  {
    let payload:any={}
    payload.method='GetProvider';
    payload.user=this.User;
    payload.company=this.Company;
    payload.parameters=searchData;
    return payload;
  }
    async search()
    {
      this.displayProviderInfo=false;
      let dataAvailable:boolean=this.providerInfoSearchData();
      if(dataAvailable){
      //let providerInfoData:any;
      //providerInfoData=await this.managerService.getProviderInformation(this.providerSearchData)
      this.additionalinfoService.getAdditionalInfo(this.providerInfoSearchPayload(this.providerSearchData)).subscribe(providerInfoData=>{
      // if(!providerInfoData)
      // {
      //   providerInfoData=await this.configService.readFileContent('/assets/Sample/MultipleProviderInfo.json')
      //   this.loaderService.display(false);
      // }
        if(providerInfoData && "Response" in providerInfoData && "Status" in providerInfoData["Response"] && providerInfoData["Response"]['Status']==1){
          if(providerInfoData && "Response" in providerInfoData && "Data" in providerInfoData["Response"]&& providerInfoData["Response"]['Data']){
            this.ProviderData=JSON.parse(providerInfoData["Response"]["Data"]);
            this.additionalinfoService.setProviderSearchData(this.providerSearchData);
            if(this.providerSearchData.Npi.trim() && this.ProviderData.length>0){
              this.ProviderData=[this.ProviderData[0]]
            }
            if(this.ProviderData.length>1){
              this.showTabularData=true;
              this.additionalinfoService.setProviderTabularData(this.ProviderData);
            }
            else{
              this.displayProviderInfo=true;
              this.additionalinfoService.setProviderInfoData(this.ProviderData);
              this.mapProviderDetails(this.ProviderData); 
            }
          }
          else
            {
              this.showModalDialog("No records found for the provided search criteria.");
            }
        }
        else
        {
          this.showModalDialog("No records found for the provided search criteria.");
        }
      })
    }
    else{
      this.showModalDialog("Please enter a valid Provider NPI, Fed ID, Full Name and/or State.");
    }
      
    }
    showModalDialog(messageText)
    {
      const initialState = { message: messageText};
      const config: ModalOptions = { class: 'modal-sm modal-dialog-centered', ignoreBackdropClick:true, keyboard:false ,initialState:initialState};
      
          this.modalRef = this.modalService.show(MessageDialogComponent,config);
          this.modalRef.content.event?.subscribe((result: any) => {});
    }
    mapProviderInfoFieldValues(providerInfoData)
    {
      
      this.FieldsConf.Groups.forEach(group => {
        group.Fields.forEach(field => {
          field["value"] = providerInfoData[0][field["Name"]];
        });
      });
      let temp=this.FieldsConf.Groups[0].Fields.filter(field=>field.Name=='FullName')
      console.log("temp",temp);
      if(temp &&temp.length>0)
      {
        this.ProviderName=temp[0]['value']
      }
    }

    mapProviderDetails(providerInfoData){
    this.mappedDetails={}
    this.fieldDetails.forEach(field=>{
      this.mappedDetails[field['label']]= providerInfoData[0][field["key"]]
      if(field['key']=='FullName'){
        this.ProviderName= providerInfoData[0][field["key"]]
      }
    })
    console.log("mappedDetails",this.mappedDetails.length,this.mappedDetails)
  }
    getAddress(address)
    {
      let addressVal:string=''
      let tempAddress=[]

      address['addressLine1']?tempAddress.push(address['addressLine1']):''
      address['addressLine2']?tempAddress.push(address['addressLine2']):''
       address['city']?tempAddress.push(address['city']):''
        address['state']?tempAddress.push(address['state']):''
      address['zipCode']?addressVal+address['zipCode']:addressVal
      
      return tempAddress.join(',')
    }
    sortByName()
    {
      if(this.sortOrder==='Asc')
      {
        this.ProviderData.sort((a,b)=>a.FullName.localeCompare(b.FullName))
      }
      else
      {
        this.ProviderData.sort((a,b)=>b.FullName.localeCompare(a.FullName))
      }
      this.sortOrder=this.sortOrder=='Asc'?'Desc':'Asc'
    }
    
    async getProviderInfo(filePath)
    {
      let InfoData:any=await this.configService.readFileContent(filePath)
      this.loaderService.display(false)
      if(InfoData && "Response" in InfoData && "Data" in InfoData["Response"]){
        return JSON.parse(InfoData["Response"]["Data"]);
      }
      return []
    }
    onRowSelect(event:any)
      {
      let providerInfoData:any=[]
        console.log("RowSelected:",event.data)
        //let providerInfoData:any=await this.getProviderInfo('/assets/Sample/SingleProviderInfo.json')
        this.additionalinfoService.getAdditionalInfo(this.providerInfoSearchPayload({PlanProvId:event.data.ProvId})).subscribe(InfoData=>{
          if(InfoData && "Response" in InfoData && "Data" in InfoData["Response"]){
            providerInfoData= JSON.parse(InfoData["Response"]["Data"]);
          if(providerInfoData.length>0)
            {
              this.showTabularData=false;
              this.displayProviderInfo=true;
              this.additionalinfoService.setProviderInfoData(providerInfoData);
              this.mapProviderDetails(providerInfoData);
            }
            else{
              this.showModalDialog("Failed to fetch details for selected record.");
            }
          }
          else{
            this.showModalDialog("Failed to fetch details for selected record.");
          }
        });
        //}
      }
      navBack()
      {
        this.showTabularData=true;
        this.displayProviderInfo=false
        this.additionalinfoService.setProviderInfoData(null)
      }

    onPageChange(event)
    {
      console.log("CurrentPage",this.currentpage)
      console.log(event)
    }
    
}

  class ProviderSearch{
    Npi:string='';
    FedId:string='';
    FullName:string='';
    State:string='';
    Gender:string='';
    ProviderType:string='';
    SpecialtyCode:string='';
    City:string='';
    County:string=''
  }